import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from './apiv6.service';
import { MessagesService } from '@core/_services/messages.service';
import { clearStorage, formatUserList, truncString } from '@core/_utils/tools.utils';

@Injectable()
export class CommonService {
    public _resetPass: boolean;
    public msg: string = '';
    public lockList = [];
    public lockStart: boolean = false;

    constructor(private router: Router, private translate: TranslateService, private api: ApiV6Service,
        protected _messageService: MessagesService) {
        this.initialize();
        this.lockList = [];
    }

    private initialize() {
        this._resetPass = false;
        this.lockStart = false;
    }

    public setMsg(aMsg) {
        this.msg = aMsg;
    }

    public checkReset() {
        if (this._resetPass === true) {
            this.router.navigate(['page-reset-pwd']);
        }
    }

    public async unlockDoc() {
        if (this.lockList.length !== 0) {
            this.lockStart = true;
            await this.execUnlockDoc();
        } 
        this.clearMessage();
        clearStorage();
    }

    public clearMessage() {
        this._messageService.clearMessage('notify');
    }

    public async execUnlockDoc() {
        let wList = '';
        this.lockList.forEach((item) => {
            wList = wList + item.doc_docid + ',';
        });
        wList = truncString(wList, 1);
        const wParams = { Docid: wList };
        try {
            try {
                await lastValueFrom(this.api.execUrlAction('logoutdocuments', wParams));
            } catch (error) {
                console.log('CommonService execUnlockDoc', error);
            }
        } finally {
            this.lockList = [];
            this.lockStart = false;
        }
    }

    public async getUserList(aUserList) {
        let wRes: any;
        wRes = await lastValueFrom(this.api.execUrlAction('getalluserlist', ''));  
        formatUserList(wRes, aUserList);
    }

    get resetPass() {
        return this._resetPass;
    }

    set resetPass(aValue) {
        this._resetPass = aValue;
    }
}
